import React from 'react'
import './Loader.css'

const Loader = () => {
    return (
        <div className='Loaderbg' role='status' aria-live='polite' aria-busy='true'>
            <div className='LoaderDiv'>
                <div className='loaderRing'>
                    <span className='loaderRingArc'></span>
                    <span className='loaderRingCore'></span>
                </div>
                <span className='loaderText'>Loading<span className='loaderDots'></span></span>
            </div>
        </div>
    )
}

export default Loader
